import { OrderDetails, OrderShortDetails } from '../../interfaces/order';
import * as AddressModel from '../address';

const orderShortDetailsFromServerFormat = (order: any): OrderShortDetails => ({
  id: order.id,
  name: order.name,
  createdAt: order.createdAt,
  financialStatus: order.financialStatus,
  fulfillmentStatus: order.fulfillmentStatus,
  totalPrice: order.totalPrice,
  shippingMethod: order.shipping.method,
  legacy: Boolean(order.legacy),
  items: order.items.map((x: { name: string }) => {
    const [productTitle, variantTitle] = x.name.split(' - ');
    return { ...x, productTitle, variantTitle };
  }),
});

export const ordersFromServerFormat = (orders: Array<any>): Array<OrderShortDetails> => {
  return orders.map(orderShortDetailsFromServerFormat);
};

export const orderDetailsFromServerFormat = (orderDetails: any): OrderDetails => ({
  ...orderShortDetailsFromServerFormat(orderDetails),
  shippingAddress: AddressModel.fromServerFormat(orderDetails.shippingAddress),
  billingAddress:
    orderDetails.billingAddress && AddressModel.fromServerFormat(orderDetails.billingAddress),
  documents: orderDetails.documents,
  totalPrice: orderDetails.totalPrice,
  totalTax: orderDetails.totalTax,
  discount: orderDetails.discount,
  totalShippingPrice: orderDetails.shipping.price,
  shipping: {
    ...orderDetails.shipping,
    currencyCode: orderDetails.currency,
  },
});
